import "./App.css";
import { Routes, Route } from 'react-router-dom';
import { useTheme } from "./contexts/Theme.context";
import { Home } from "./components/Home";
import { NotFound } from "./components/NotFound";
import { Navbar } from "./components/Navbar";
import Footer from "./components/Footer";
import { Contact } from "./components/Contact";
import { Portfolio } from "./components/Portfolio";

function App() {
  const { theme, oppositeTheme } = useTheme();
  return (
    <>
        <div className={`App ${theme} text-${oppositeTheme}`}>
          <Navbar />
          <Routes>
            <Route index element={<><Home /></>} />
            <Route path="/portfolio" element={<><Portfolio /></>} />
            <Route path="/contact" element={<><Contact /></>} />
            <Route path="*" element={<><NotFound /></>} />
          </Routes>
          <Footer />
        </div>
    </>
  );
}

export default App;
